import React from 'react';

const ChartActivity = ({ records }) => {
  const totalRecords = records.length;

  const lastRecordDate = records.length
    ? new Date(
        Math.max(...records.map(r => new Date(r.date).getTime()))
      ).toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }).replace(' de ', '-').replace(' de ', '-')
    : '—';

  return (
    <div className="h-32 md:h-56 bg-white shadow-lg rounded-xl p-3 flex flex-col justify-between">
      <span className="text-md font-semibold">Activity</span>
      <div className="flex items-center justify-around h-full pb-4">
        <div className="text-center">
          <div className="text-3xl font-bold">{lastRecordDate}</div>
          <div className="text-sm font-semibold text-gray-700">last record</div>
        </div>
        <div className="text-center">
          <div className="text-3xl font-bold">{totalRecords}</div>
          <div className="text-sm font-semibold text-gray-700">total records</div>
        </div>
      </div>
    </div>
  );
};

export default ChartActivity;
